import clsx from "clsx";
import styles from "./index.module.scss";

type Props = {
  children: React.ReactNode;
  menu?: boolean;
  center?: boolean;
  hasShadow?: boolean;
  isMarginBottom?: boolean;
  isBorderBottom?: boolean;
};

//TODO: コンポーネント名変えて Crew | Ownerで共通化した方が良さそう（Ownerでもう使ってるけど。。）
const CrewNavigationBar: React.FC<Props> = ({
  children,
  menu,
  center,
  hasShadow = true,
  isMarginBottom = false,
  isBorderBottom = false
}) => {
  return (
    <div
      className={clsx(
        menu
          ? styles.wrapper__menu
          : center
            ? styles.wrapper__center
            : styles.wrapper,
        isMarginBottom ? "mb-[8rem]" : "",
        hasShadow
          ? "shadow-[0_-0.5rem_0.5rem_rgba(0,0,0,0.1)]"
          : "border-divider border-t",
        isBorderBottom ? "border-b border-borderDivider" : ""
      )}
    >
      {children}
    </div>
  );
};

export default CrewNavigationBar;
